<div class="restaurant-menu-container">
    <h2 class="widget-header h4" i18n="@@restaurant-menu-header">Restaurant menus</h2>
    <div class="d-flex justify-content-between">
        <div>
            <h3 class="text-muted h6" i18n="@@restaurant-menu-sub-header">
                Hungry? Have a look at what's on the menu for week {{currentWeekNumber}} ({{startOfISOWeek | date:'shortDate'}} - {{endOfISOWeek | date:'shortDate'}})
            </h3>
        </div>
        <div *ngIf="restaurants$ | async as restaurants" class="d-flex align-self-start restaurant-selector-container">
            <span class="bolder" i18n="@@restaurant-menu-list-title" id="restaurant_label">Restaurant</span>:
            <div class="ml-1 restaurant-selector focus-border">
                <mat-select (selectionChange)="handleSelection($event)" role="listbox" placeholder="Select a restaurant" [(value)]="selectedRestaurant" i18n-aria-label="@@restaurant-menu-list-title" aria-label="Restaurant">
                    <mat-option *ngFor="let restaurant of restaurants" aria-label="{{restaurant.Name}}" role="option" [value]="restaurant.Id">{{restaurant.Name}}</mat-option>
                </mat-select>
            </div>
        </div>
    </div>
</div>

<div *ngIf="restaurantMenus$ | async as restaurantMenus; else loading" class="restaurant-menu-container">
    <div *ngFor="let restaurantMenu of restaurantMenus" class="row">
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Monday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@monday">Monday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Monday}}">
                        {{restaurantMenu.Monday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Tuesday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@tuesday">Tuesday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Tuesday}}">
                        {{restaurantMenu.Tuesday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Wednesday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@wednesday">Wednesday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Wednesday}}">
                        {{restaurantMenu.Wednesday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Thursday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@thursday">Thursday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Thursday}}">
                        {{restaurantMenu.Thursday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Friday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@friday">Friday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Friday}}">
                        {{restaurantMenu.Friday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Saturday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@saturday">Saturday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Saturday}}">
                        {{restaurantMenu.Saturday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.Sunday">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@sunday">Sunday</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.Sunday}}">
                        {{restaurantMenu.Sunday}}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-6 col-xxl-4 mt-3" *ngIf="restaurantMenu.AllWeek">
            <div class="restaurant-menu-card p-4 h-100">
                <span class="restaurant-menu-day-header text-uppercase pl-2 pr-2 pt-1 pb-1" i18n="@@allweek">All week</span>
                <div class="mt-4">
                    <span class="menu-description" title="{{restaurantMenu.AllWeek}}">
                        {{restaurantMenu.AllWeek}}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="restaurantMenus && restaurantMenus.length === 0">
        <app-text-placeholder>
            <p i18n="@@restaurant-menu-no-restaurant-menus">There are no menus for the restaurant this week.</p>
        </app-text-placeholder>
    </div>
</div>

<ng-template #loading>
    <app-widget-placeholder></app-widget-placeholder>
</ng-template>
